import { render } from "./AccountConfirm.vue?vue&type=template&id=9b8807a2&scoped=true"
import script from "./AccountConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountConfirm.vue?vue&type=script&setup=true&lang=js"

import "./AccountConfirm.vue?vue&type=style&index=0&id=9b8807a2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b8807a2"],['__file',"src/views/account/AccountConfirm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9b8807a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9b8807a2', __exports__)) {
    api.reload('9b8807a2', __exports__)
  }
  
  module.hot.accept("./AccountConfirm.vue?vue&type=template&id=9b8807a2&scoped=true", () => {
    api.rerender('9b8807a2', render)
  })

}


export default __exports__